module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirafalow0006#intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirafalow0007#ch01"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-left": "0.25em"
    }
  }, [_vm._v("Similar Technologies, Different Schools")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirafalow0008#ch02"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-left": "0.25em"
    }
  }, [_vm._v("Disciplining Play")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirafalow0009#ch03"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-left": "0.25em"
    }
  }, [_vm._v("Where Disciplinary Orientations Come From")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirafalow0010#ch04"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-left": "0.25em"
    }
  }, [_vm._v("Schools as Socializing Agents for Digital Participation")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirafalow0011#conc"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirafalow0012#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirafalow0013#app"
    }
  }, [_vm._v("Appendix: Methodology")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirafalow0014#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirafalow0015#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-622b1a97","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-rafalow-0005.vue
// module id = 66
// module chunks = 0